/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react';
import { FontIcon, Stack, Link, SearchBox } from '@fluentui/react';

export const DoubleListBox = (props) => {
  const { data, selectorHeader } = props;

  const [options, setOptions] = useState(data);
  const [searchQuery, setQuery] = useState('');

  function notify() {
    props.onChange(options.filter(option => option.selected));
  }

  const select = (option) => {
    option.selected = true; // eslint-disable-line no-param-reassign
    setOptions([...options]);

    notify();
  };

  const deselect = (option) => {
    option.selected = false; // eslint-disable-line no-param-reassign
    setOptions([...options]);

    notify();
  };

  const removeAll = () => {
    // eslint-disable-next-line no-return-assign
    options.filter(item => item.selected).forEach(option => option.selected = false); // eslint-disable-line no-param-reassign
    setOptions([...options]);

    notify();
  };

  const selectAll = () => {
    // eslint-disable-next-line no-return-assign
    options.forEach(option => option.selected = true); // eslint-disable-line no-param-reassign
    setOptions([...options]);

    notify();
  };

  const onSearch = (query) => {
    setQuery(query.toLowerCase());
  };

  return (
    <div className="doublelistbox" style={{ display: 'flex' }} >
      <div className="doublelistbox-entity-selector" style={{ width: 460, border: '1px solid gray', marginRight: 10 }} >
        <SearchBox placeholder="Search" onSearch={onSearch} />
        <Stack horizontal tokens={{ padding: 8 }} horizontalAlign="space-between" styles={{ root: { alignItems: 'center' } }} >
          <h5>{selectorHeader}</h5>
          <Link onClick={selectAll} >Select all</Link>
        </Stack>

        <div style={{ maxHeight: 300, overflow: 'auto' }} >
          {options.filter(option => option.name.toLowerCase().includes(searchQuery)).map(item => (
            <Stack onClick={() => select(item)} styles={{ root: { cursor: 'pointer' } }} horizontal horizontalAlign="space-between" tokens={{ padding: 5 }} >
              <div className="select" style={{ height: 30 }} >{item.name}</div>
              <div>{!item.selected && <FontIcon iconName="Add" />}</div>
            </Stack>
            ))}
        </div>
      </div>
      <div className="doublelistbox-result-container" style={{ width: 460, border: '1px solid gray', padding: 8 }} >
        <h5>Selected: {options.filter(item => item.selected).length}</h5>
        <Link onClick={removeAll} >Remove all</Link>
        <div style={{ maxHeight: 300, overflow: 'auto' }}>
          {options.filter(item => item.selected).map(item => (
            <Stack onClick={() => deselect(item)} styles={{ root: { cursor: 'pointer' } }} horizontal horizontalAlign="space-between" tokens={{ padding: 5 }} >
              <div className="deselect" >{item.name}</div>
              <div><FontIcon iconName="Remove" /></div>
            </Stack>
          ))}
        </div>
      </div>
    </div>
  );
};
